export const profile = {
  name: 'Andrew Zinkel, MD, MBA',
  shortName: 'Dr. Andrew Zinkel',
  title: 'Physician Executive · Healthcare AI Innovator · Venture Partner',
  photo:
    'https://cdn.magicpatterns.com/uploads/dDd3R9SNtV1yXjJmSYXSvY/7777777777.jpg',
  locations: 'Greater Minneapolis–St. Paul Area · San Francisco, CA',
  linkedin: 'https://www.linkedin.com/',
}

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Core Expertise', to: '/expertise' },
  { label: 'Experience', to: '/experience' },
  { label: 'Advisory & Board', to: '/advisory' },
  { label: 'Thought Leadership', to: '/thought-leadership' },
  { label: 'Contact', to: '/contact' },
]

export const metrics = [
  { value: '20+', label: 'Years Healthcare Leadership' },
  { value: '2M+', label: 'Covered Lives Impacted' },
  { value: '13', label: 'Hospitals & 100+ Clinics Led' },
  { value: '30%+', label: 'Growth in Strategic Partnerships' },
]

export const pillars = [
  {
    title: 'Healthcare AI & Digital Health Innovation',
    body: 'Driving market adoption, clinical governance, and personalized health analytics across enterprise care settings.',
  },
  {
    title: 'Venture Capital & Startup Advisory',
    body: 'Guiding portfolio growth, investment theses, and commercialization strategies for early-stage founders and funds.',
  },
  {
    title: 'Executive Governance & Quality',
    body: 'Sustaining NCQA Excellent Accreditation, leading 60+ physician teams, and driving value-based care outcomes.',
  },
]

export const expertise = [
  {
    title: 'Healthcare AI & Predictive Analytics',
    body: 'Clinical decision support, model governance, and safe deployment inside live clinical workflows.',
  },
  {
    title: 'Venture Capital & Angel Investing',
    body: 'Diligence, investment theses, and operator-level pattern recognition in digital health.',
  },
  {
    title: 'Board Governance & Strategy',
    body: 'Fiduciary oversight, quality committee leadership, and long-range strategic planning.',
  },
  {
    title: 'Clinical Quality & Patient Safety',
    body: 'Enterprise quality programs, accreditation, and high-reliability operating models.',
  },
  {
    title: 'Telehealth & Virtual Care Delivery',
    body: 'Virtual-first care design, access expansion, and hybrid staffing models.',
  },
  {
    title: 'Value-Based Care & Population Health',
    body: 'Risk-bearing contracts, total cost of care, and population analytics.',
  },
]

export const roles = [
  {
    period: 'Present',
    title: 'Chief Medical Officer',
    org: 'PointHealth AI',
    body: 'Leading AI-driven clinical decision support, driving double-digit revenue growth, and expanding investor networks.',
    tags: ['Healthcare AI', 'Commercial Growth', 'Clinical Governance'],
  },
  {
    period: 'Present',
    title: 'Founder & Chief Executive Officer',
    org: 'Accelerence Healthcare Advising',
    body: 'Advising early-stage digital health and medtech founders on scaling, market entry, and clinical validation.',
    tags: ['Advisory', 'Go-to-Market', 'Medtech'],
  },
  {
    period: 'Present',
    title: 'Venture Partner & Expert Advisor',
    org: 'NextGen Venture Partners & Alumni Ventures',
    body: 'Connecting portfolio companies with strategic capital, health system access, and commercial partnerships.',
    tags: ['Venture Capital', 'Diligence', 'Portfolio Support'],
  },
  {
    period: 'Prior',
    title: 'Senior Executive Medical Director & Associate Professor',
    org: 'University of Minnesota Physicians',
    body: 'Overseeing emergency department operations serving 100,000+ annual patient visits across an academic network.',
    tags: ['Operations', 'Academic Medicine', 'Emergency Care'],
  },
  {
    period: 'Prior',
    title: 'Associate Medical Director of Quality',
    org: 'HealthPartners',
    body: 'Directing enterprise quality across 2M+ members, sustaining NCQA Excellent Accreditation and value-based performance.',
    tags: ['Quality', 'Accreditation', 'Population Health'],
  },
]

export const advisory = [
  {
    title: 'Board & Committee Leadership',
    body: 'Independent director and quality-committee leadership for health systems, health plans, and venture-backed companies.',
    points: [
      'Quality & safety oversight',
      'Clinical risk governance',
      'Clinical AI oversight frameworks',
    ],
  },
  {
    title: 'Venture & Investor Advisory',
    body: 'Clinical diligence and thesis development for funds investing across digital health and care delivery.',
    points: [
      'Technical & clinical diligence',
      'Market sizing & buyer mapping',
      'Portfolio operating support',
    ],
  },
  {
    title: 'Strategic Consulting',
    body: 'Executive advisory for health systems and growth-stage companies navigating adoption and value-based models.',
    points: [
      'Technology adoption roadmaps',
      'Virtual care strategy',
      'Partnership & channel design',
    ],
  },
]

export const education = [
  {
    school: 'Columbia Business School',
    credential: 'Senior Executive Program in Venture Capital & Private Equity',
  },
  {
    school: 'MIT Sloan Executive Education',
    credential: 'Executive Certificate in Strategy and Innovation',
  },
  {
    school: 'UMN Carlson School of Management',
    credential: 'MBA, Medical Industry Leadership & Entrepreneurship',
  },
  {
    school: 'University of Wisconsin–Madison',
    credential: 'Doctor of Medicine (M.D.)',
  },
]

export const certifications = [
  'Board Certified — Emergency Medicine',
  'Board Certified — Medical Quality (CMQ)',
  'Fellow, American College of Emergency Physicians (FACEP)',
]

export const insights = [
  {
    kind: 'Perspective',
    title: 'Governing Clinical Technology: What Boards Should Ask Before Deployment',
    body: 'A practical oversight framework for directors evaluating new decision-support tools in live clinical workflows.',
  },
  {
    kind: 'Speaking',
    title: 'From Pilot to P&L: Why Digital Health Stalls Inside Health Systems',
    body: 'The operating realities that separate durable enterprise contracts from indefinite pilot programs.',
  },
  {
    kind: 'Investor Note',
    title: 'Underwriting Clinical Risk in Early-Stage Digital Health',
    body: 'How clinical evidence, workflow fit, and reimbursement pathways should shape venture diligence.',
  },
]

export const inquiryTypes = [
  'Board Role',
  'Startup Advisory',
  'VC Consulting',
  'Speaking',
]
